<!-- <div class="all-destination-container">
</div> -->
<div>
    <svg class="svg-size">
        <image height="100%" width="100%" xlink:href="./assets/images/group-map.svg"/>
    </svg>
</div>
<div class="all-destination">
    <h1 class="all-destination--title">{{'ALL_DESTINATIONS' | translate}}</h1>
    <!-- <p class="all-destination--text">We fly to over 100 destinations covering the main cities in Spain, Europe, North Africa and the Near East, with direct
        flight or flights with connection in Barcelona and Rome. You’ll be amazed to discover all the places we can fly you
        to from your city. And, as we know you want more, we’ll continue to expand our list of destinations.</p> -->
</div>
<div class="mdl-cell--hide-phone mdl-cell--hide-tablet continents">
    <ul>
        <div class="continents-wrapper">
            <li value="0" [ngClass]="{'li-selected':continentID == 0}" (click)="sortByContinent($event)">{{'ALL_DESTINATIONS' | translate}}</li>
        </div>
        <div class="continents-wrapper">
            <li value="3" [ngClass]="{'li-selected':continentID == 3}" (click)="sortByContinent($event)">{{'AFRICA' | translate}}</li>
        </div>
        <div class="continents-wrapper">
            <li value="6" [ngClass]="{'li-selected':continentID == 6}" (click)="sortByContinent($event)">{{'OCEANIA' | translate}}</li>
        </div>
        <div class="continents-wrapper">
            <li value="1" [ngClass]="{'li-selected':continentID == 1}" (click)="sortByContinent($event)">{{'EUROPE' | translate}}</li>
        </div>
        <div class="continents-wrapper">
            <li value="5" [ngClass]="{'li-selected':continentID == 5}" (click)="sortByContinent($event)">{{'SOUTH_AMERICA' | translate}}</li>
        </div>
        <div class="continents-wrapper">
            <li value="4" [ngClass]="{'li-selected':continentID == 4}" (click)="sortByContinent($event)">{{'NORTH_AMERICA' | translate}}</li>
        </div>
        <div class="continents-wrapper">
            <li value="2" [ngClass]="{'li-selected':continentID == 2}" (click)="sortByContinent($event)">{{'ASIA' | translate}}</li>
        </div>
    </ul>
</div>
<div class="mdl-cell--hide-desktop all-selects">
    <select title="Continents" (change)="sortByContinent($event)">
        <option value="0">{{'CONTINENTS' | translate}}</option>
        <option value="1">{{'EUROPE' | translate}}</option>
        <option value="2">{{'ASIA' | translate}}</option>
        <option value="3">{{'AFRICA' | translate}}</option>
        <option value="4">{{'NORTH_AMERICA' | translate}}</option>
        <option value="5">{{'SOUTH_AMERICA' | translate}}</option>
        <option value="6">{{'OCEANIA' | translate}}</option>
    </select>
    <select title="Countries" (change)="changeCountry($event.target.value)">
            <option selected value="-1">{{'COUNTRIES' | translate}}</option>
            <option *ngFor="let country of countriesSelect" [value]="country">{{country}}</option>
    </select>
</div>
<div class="country">
    <h3 class="country-text">{{'COUNTRIES' | translate}}</h3>
    <div class="country-details">
        <ng-container *ngFor="let letter of alphabet">
            <div class="letters">
                <h3 class="letters--unique">{{letter | uppercase}}</h3>
                <div class="letters--content">
                    <ng-container *ngFor="let c of destinationObject">
                        <ng-container *ngIf="letter == c.firstLetter">
                            <ng-container *ngIf="!c.hidd">
                                <p class="country-country--name fade-in">{{c.countryName}}</p>
                                <ng-container *ngFor="let location of c.location">
                                    <a  class="country-location fade-in" [routerLink]="getUrl(location)">{{location.name}}</a>
                                </ng-container>
                            </ng-container>
                        </ng-container>
                    </ng-container>
                </div>
            </div>
        </ng-container>
    </div>
</div>